/**
 * Testimonial Slider - Initializes A11YSlider on the testimonial element.
 */
import A11YSlider from 'a11y-slider';

export function setupTestimonialSlider(): void {
    const sliderElement = document.querySelector<HTMLElement>('.slider');
    if (!sliderElement) return;

    new A11YSlider(sliderElement, {
        slidesToShow: 1,
        dots: true,
        arrows: true,
    });
}

// Auto-initialize when loaded as entry
setupTestimonialSlider();
